import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Field of study %{fieldOfStudy} not found').i__({
        fieldOfStudy: inputValue,
      })
    : __('Search for a field of study');

const ReactSelectFieldOfStudies = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    multiple={multiple || isMulti}
    loadOptionsUrl={Routes.search_field_of_studies_path({ format: 'json' })}
    placeholder={placeholder || __('Field of study')}
    noOptionsMessage={noOptionsMessage}
  />
);

ReactSelectFieldOfStudies.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectFieldOfStudies;
